import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UsuarioService } from '../../services/usuario.service';
import { UsuarioLogado } from '../../interfaces/usuario/usuario-logado.interface';
import { PwaManagerService, ROTAS_TELAO } from '../../services/pwa-manager.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  mostrarSidebar = true;
  withPadding = true;
  openSidebar = true;
  isHomologacao = true;
  isTelaoUser = false;
  showUpdateBar = false;
  showInstallBar = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router, 
    private usuarioService: UsuarioService,
    private pwaManager: PwaManagerService
  ){
    this.isHomologacao = environment.ambiente == "HOM" ? true : false;
    const versao = localStorage.getItem('versao');
    if(versao){
      if(environment.versao > parseInt(versao)){
        usuarioService.removeUsuarioLogado();
        router.navigateByUrl('/autenticacao/login');
      }
    }else{
      usuarioService.removeUsuarioLogado();
      router.navigateByUrl('/autenticacao/login');
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.usuarioService.getUsuarioLogado().subscribe((usuario: UsuarioLogado) => {
          if(usuario?.nome == 'telao'){
            this.isTelaoUser = true;
            this.openSidebar = false;
            this.mostrarSidebar = !ROTAS_TELAO.includes(event.urlAfterRedirects);
            this.withPadding = !ROTAS_TELAO.includes(event.urlAfterRedirects);
          } else {
            this.isTelaoUser = false;
          }
        });
      }
    });
  }

  ngOnInit() {
    // Monitorar atualizações PWA
    this.pwaManager.updateAvailable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(available => {
        this.showUpdateBar = available;
      });

    // Monitorar possibilidade de instalação PWA
    this.pwaManager.installable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(installable => {
        this.showInstallBar = installable;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar(): void {
    console.log("toggleSidebar");
    this.openSidebar = !this.openSidebar;
  }

  getMainContentClass(): string {
    if (this.isTelaoUser && !this.mostrarSidebar) {
      return 'sidebar-fullscreen';
    }
    return this.openSidebar ? 'sidebar-expanded' : 'sidebar-collapsed';
  }
}
